export const ACTION_SET_FOCUS_STATUS = 'ACTION_SET_FOCUS_STATUS';

export const setFocusState = (payload) => ({type: ACTION_SET_FOCUS_STATUS, payload});